import NearestEvents from 'components/Pages/Main/NearestEvents/NearestEvents';
import Directions from 'components/Pages/Main/Directions/Directions';
import Feedback from 'components/Pages/Main/Feedback/Feedback';
import LastNews from 'components/Pages/Main/LastNews/LastNews';
import EcdsCta from 'components/Pages/Main/EcdsCta/EcdsCta';
import Stats from 'components/Pages/Main/Stats/Stats';
import About from 'components/Pages/Main/About/About';
import Hero from 'components/Pages/Main/Hero/Hero';

/**
 * Головна сторінка — ADR-0006, ADR-0018.
 *
 * Порядок блоків: хто ми, місток на реєстрацію в ECDS, масштаб, про нас, чим
 * займаємося, де ми є, що відбувається, що пишемо, як зв'язатися. Блок «База даних» вилучено за
 * рішенням власника сайту; перехід у кабінет e-phan і розмір членського
 * внеску лишаються в EcdsCta одразу під Hero.
 *
 * Старий блок «Що робить СГОСТУ» замінено новим блоком Directions (ADR-0018):
 * назви напрямків видно одразу, опис розкривається на вимогу. Карта клубів
 * (ADR-0014) на проді тимчасово не показується — рішення власника лишається
 * в стеші (`git stash list`) до окремого запуску.
 *
 * Даних сторінка більше не завантажує: кожна секція питає свій розділ сама і
 * сама показує своє завантаження чи помилку. Тому збій новин не робить порожньою
 * всю головну, а секція заходів не чекає на новини.
 */
export default function Main() {
  return (
    <>
      <Hero />
      <EcdsCta />
      <Stats />
      <About />
      <Directions />
      <NearestEvents />
      <LastNews />
      <Feedback />
    </>
  );
}
